import styled from 'styled-components'
import UncheckedIcon from '../../asset/checkboxUnchecked.svg'
import CheckedIcon from '../../asset/checkboxChecked.svg'
import DirectionDownIcon from '../../asset/direction-down.svg'
import theme from '../../styles/theme'
import externalLinkIcon from '../../asset/external-link.svg'
import TooltipIcon from '../../asset/tooltip.svg'
export const CheckBoxGroup = styled.div`
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  text-size-adjust: 100%;
  color: ${theme.color.black};
`
export const CheckBoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  box-shadow: inset 0px -3px 0px ${theme.color.boxShadow};
  padding-top: 10px;
  padding-bottom: 10px;
`
export const CheckBoxTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 0px;
  color: ${theme.color.black};
`

export const CheckContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  box-shadow: inset 0px -1px 0px ${theme.color.boxShadow};
`

export const CheckWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 0 0 0.5rem 0;
  margin-left: 0.75rem;
  width: 100%;
`

export const CheckInput = styled.input`
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  cursor: pointer;
  margin: 0;
  margin-left: 0.5rem;

  &:checked + label:after {
    background-image: url(${CheckedIcon});
  }
  &:focus + label:before {
    outline: 3px solid ${theme.color.focus};
    outline-offset: 2px;
    text-decoration: none !important;
    color: ${theme.color.black} !important;
    z-index: 10;
  }
`

export const CheckLabel = styled.label`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.5;
  padding: 4px 8px 8px 40px;
  padding: 0.25rem 0.5rem 0.5rem 2.5rem;
  margin: 0 1rem 0 0.5rem;
  display: block;
  font-family: inherit;
  color: ${theme.color.black};
  width: 100%;

  &:before {
    background-image: url(${UncheckedIcon});
    width: 2.375rem;
    height: 2.375rem;
    content: ' ';
    display: block;
    position: absolute;
    box-sizing: border-box;
    background-repeat: no-repeat;
    z-index: 10;
    left: -3px;
    top: -3px;
    border: 3px solid transparent;
  }

  &:after {
    background-image: none;
    width: 2.375rem;
    height: 2.375rem;
    content: ' ';
    display: block;
    position: absolute;
    box-sizing: border-box;
    background-repeat: no-repeat;
    z-index: 11;
    left: -3px;
    top: -3px;
    border: 3px solid transparent;
  }
`

export const Title = styled.h3`
  font-size: 1rem;
  margin-right: 1rem;
  display: block;
  color: ${theme.color.black};
  font-weight: bold;
`

export const Text = styled.p`
  line-height: 1.6;
  margin-bottom: 0;
`

export const InfoModalIcon = styled.button`
  width: 26px;
  height: 25px;
  margin: 0px 15px 0px 0px;
  border: none;
  background: url(${TooltipIcon});
  font-size: 0;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const AccordionCheckWrapper = styled(CheckWrapper)`
  padding: 0;
`
export const AccordionCheckLabel = styled(CheckLabel)`
  padding: 0.25rem 0.5rem 0rem 2.5rem;
`
export const AccordionWrapper = styled.div`
  padding: 0 0 1rem 3.75rem;
`

export const AccordionButton = styled.button`
  font-size: 1rem;
  line-height: 1.5;
  display: flex;
  color: ${theme.color.action};
  appearance: none;
  background: transparent;
  cursor: pointer;
  text-decoration-skip-ink: auto;
  align-items: center;
  text-decoration: underline;
  border: none;
  padding: 0;
  ::after {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin: 0 0.25rem;
    content: '';
    transition: transform 0.25s ease-in;
    transform: ${(props) =>
      props['aria-expanded'] ? 'rotate(180deg)' : 'none'};
    background-image: url(${DirectionDownIcon});
  }
`

export const AccordionContent = styled.div`
  display: flex;
  padding: 0 1rem 0 0;
  flex-direction: column;
  font-size: 1rem;
  line-height: 1.5;
  overflow: auto;
  height: auto;
  max-height: ${(props) => (props['aria-hidden'] ? '0' : '18rem')};
  transition: max-height 0.25s ease-in;

  & > p {
    margin-bottom: 1rem;
    & > a {
      text-decoration: underline;
      :after {
        display: inline-block;
        content: '';
        background-image: url(${externalLinkIcon});
        background-size: 15px 15px;
        height: 15px;
        width: 15px;
      }
      &:hover {
        color: ${theme.color.text};
      }
    }
  }
  & > div {
    padding-top: 1rem;
  }
`
